import { Application } from 'reduxState/store/application/types';

export const getAppOptions = (apps: Application[]) => {
  return apps.map(({ id, name }) => ({ label: `${id} - ${name}`, id })).sort((a, b) => parseInt(a.id) - parseInt(b.id));
};
